import requestCardTypeList from '@/api/cardType';

const state = {
  cardTypeList: null,
};

const getters = {
  cardTypeList: (state) => state.cardTypeList,
};

const actions = {
  async setCardTypeList({ commit, dispatch }) {
    await dispatch('setIsLoading', true, { root: true });
    const result = await requestCardTypeList();
    commit('setCardTypeList', result);
    await dispatch('setIsLoading', false, { root: true });
  },
};

const mutations = {
  setCardTypeList(state, cardTypeList) {
    state.cardTypeList = cardTypeList.data.list;
  },
};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations,
};
